let keycloak = {
    url : '',
    realms : "Fi360",
    clientId : "fi360",
    clientSecret: "o5jPIwH1EZ88TDb8ulUnYMqBq12KtcSY",
    callbackUrl : "https://app.fi360.fr/sso/call",
    scope : "openid profile email",
    keycloakUrl : ''
};

keycloak.url = 'https://sso.md-pro.fr/realms/' + keycloak.realms + '/protocol/openid-connect/auth?response_type=code&client_id=' + keycloak.clientId + '&redirect_uri=' + keycloak.callbackUrl + '&scope=' + keycloak.scope;
keycloak.keycloakUrl = 'https://sso.md-pro.fr/realms/' + keycloak.realms + '/protocol/openid-connect';

let config = {
    urlAPI : 'https://api.fi360.fr',
    urlAdmin : 'https://admin.fi360.fr',
    activeWorker : false,
    keycloak : keycloak,
    discordWebhookUrl : "https://discord.com/api/webhooks/1471791710203019486/BaQWZwL8rqyuJg8roRbDlUpdTQxQpg2T70pur7ani5lhBnH8lrBuMzXzH2M9JFRFyE0o"
};

export default config



// WEBPACK FOOTER //
// ./src/js/config.js